/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from "react";
import AddActivity from "./AddActivity";
import { BiEdit } from "react-icons/bi";
import { MdDeleteForever } from "react-icons/md";
import { BsThreeDotsVertical } from "react-icons/bs";
import { IoSearch } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { deleteActivity, GetActivity, getMarkAsActivity } from "./ActivitySlice";
import { getByIdApiActivity } from "../../Redux/CommonSlice";
import sweetAlert from "../Common/sweetAlert";
import Loading from "../Common/Loading";
import { FaPlus } from "react-icons/fa6";
import { getActivityIcon } from "../Common/Common";
import { RxDotsHorizontal } from "react-icons/rx";
import * as XLSX from 'xlsx';
import axios from "axios";
import { IMPORT_ACTIVITY } from "../Common/API";
import toast from "react-hot-toast";
import FullCalender from "./FullCalender";
import moment from "moment";
import debounce from 'lodash/debounce';
import Pagination from "../Common/Pagination";

export default function Activity({
  isVisible,
  setIsVisible,
  setSidebarOpen,
  sidebarOpen,
  isDark,
  setIsDark,
}) {
  const dispatch = useDispatch();
  const store = useSelector((state) => state.root.Activity);
  const { token } = useSelector((state) => state.root.auth);
  const authToken = `Bearer ${token}`;

  const [loadFist, setloadFrist] = useState(true);
  const [loading, setloading] = useState(true);
  const [openModel, setOpenModel] = useState(false);
  const [ActivityData, setActivityData] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedActivitysIds, setSelectedActivitysIds] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortedField, setSortedField] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");
  const [AciteOption, setAciteOption] = useState(false);
  const [activeButton, setActiveButton] = useState(1);
  const [openActionMenuId, setOpenActionMenuId] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setrowsPerPage] = useState(10)
  const totalPages = Math.ceil(store.getAllActivity?.totalRows / rowsPerPage);

  useEffect(() => {
    const handleOutsideClick = () => setOpenActionMenuId(null);
    document.addEventListener("click", handleOutsideClick);
    return () => document.removeEventListener("click", handleOutsideClick);
  }, []);

  const fetchActivities = useCallback(
    debounce(async (search) => {
      setloading(true);
      const query = { search, limit: rowsPerPage, pageNumber: currentPage - 1, objSearch: {} };

      await dispatch(GetActivity(query))
      setloading(false);
    }, 300), // Adjust debounce delay as needed
    [dispatch, currentPage, rowsPerPage]
  );

  useEffect(() => {
    if (loadFist) {
      fetchActivities(searchTerm);
      setloadFrist(false);
    }
  }, [fetchActivities, loadFist, searchTerm, currentPage, rowsPerPage]);

  useEffect(() => {
    fetchActivities(searchTerm);
  }, [searchTerm, fetchActivities,]);

  const togglemodel = () => {
    setOpenModel(!openModel);
    setActivityData([]);
  };

  const handleButtonClick = (buttonIndex) => {
    setSearchTerm('')
    setActiveButton(buttonIndex);
    // setloadFrist(true)
  };

  const handleSelectAll = () => {
    setSelectAll(!selectAll);
    if (!selectAll) {
      const allDealIds = store?.getAllActivity?.data.map(
        (activity) => activity.activityID
      );
      setSelectedActivitysIds(allDealIds);
    } else {
      setSelectedActivitysIds([]);
    }
  };

  const handleCheckboxChange = (productId) => {
    let updatedSelectedActivitytIds;

    if (selectedActivitysIds.includes(productId)) {
      updatedSelectedActivitytIds = selectedActivitysIds.filter(
        (id) => id !== productId
      );
    } else {
      updatedSelectedActivitytIds = [...selectedActivitysIds, productId];
    }

    setSelectedActivitysIds(updatedSelectedActivitytIds);
    const allRowsSelected =
      updatedSelectedActivitytIds.length === store.getAllActivity?.data.length;
    setSelectAll(allRowsSelected);
  };


  const handleSort = (field) => {
    if (sortedField === field) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortOrder("asc");
      setSortedField(field);
    }
  };

  const sortData = (data, sortedField, sortOrder) => {
    const sortedData = data ? [...data] : [];
    sortedData.sort((a, b) => {
      const aTrimmed = a[sortedField]?.trim() || '';
      const bTrimmed = b[sortedField]?.trim() || '';
      if (sortOrder === "asc") {
        return aTrimmed?.localeCompare(bTrimmed);
      }
    });
    return sortedData;
  };
  const sortedActivities = sortData(store?.getAllActivity?.data, sortedField, sortOrder);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const EditActivity = async (id) => {
    const result = await dispatch(getByIdApiActivity(id));
    if (result) {
      setActivityData(result.payload.data);
    }
  };

  const DeleteActivitys = async () => {
    try {
      const result = await sweetAlert.confirm("Are you sure?", "Are you sure you want to delete this!");
      if (result.isConfirmed) {
        dispatch(deleteActivity(selectedActivitysIds)).then((res) => {
          if (res.payload.status === true) {
            setCurrentPage(1)
            setloadFrist(true);
          }
        });
        sweetAlert.success("Deleted successfully");
      }
    } catch (error) {
      console.error("Error:", error);
      sweetAlert.error("An error occurred");
    }
    setSelectedActivitysIds([]);
    setSelectAll(false);
  };

  const handleExport = () => {
    const data = store?.getAllActivity?.map(item => ({
      ActivityName: item.activityName,
      ActivityType: item.activityType,
      AvailableType: item.availableType,
      Notes: item.notes,
      PeopleName: item.peopleName,
      OrganizationName: item.organizationName,
      Guests: item?.guests,
      Locations: item.locations,
      MeetingType: item.meetingType,
      Description: item.description,
      MarkAsDone: item.markAsDone,
      IdentityName: item.identityName,
      DealTitle: item.dealName,
      Day: item.day,
    }));
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Leads");
    XLSX.writeFile(workbook, "activity_data.xlsx");
    setAciteOption(!AciteOption)
  };

  const uploadExcel = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('ExcelFilePath', file);

    try {
      const response = await axios.post(IMPORT_ACTIVITY, formData, {
        headers: { Authorization: authToken, 'Content-Type': 'multipart/form-data' },
      });

      if (response.data.status === true) {
        setAciteOption(!AciteOption)
        toast.success(response?.data?.message)
      }
    } catch (error) {
      console.error('Upload error:', error);
    }
  };

  const getRowColorClass = (endDate) => {
    const now = moment();
    const date = moment(endDate);
    if (date.isBefore(now, 'day')) {
      return 'text-red-600 font-bold'; // Yesterday and previous dates
    } else if (date.isSame(now, 'day')) {
      return 'text-green-600'; // Today
    } else {
      return 'text-gray-500';
    }
  };

  const totalActs = store?.getAllActivity?.totalRows || 0;
  const doneActs = store?.getAllActivity?.data?.filter(a => a?.markAsDone).length || 0;
  const todoActs = store?.getAllActivity?.data?.filter(a => !a?.markAsDone).length || 0;
  const callActs = store?.getAllActivity?.data?.filter(a => a?.activityType?.toLowerCase() === 'call').length || 0;
  const meetingActs = store?.getAllActivity?.data?.filter(a => a?.activityType?.toLowerCase() === 'meeting').length || 0;
  const highPriorityActs = store?.getAllActivity?.data?.filter(a => a?.priority?.toLowerCase() === 'high').length || 0;

  return (
    <div>
      <div className="flex flex-1">
        <div className="page-wrapper relative ml-auto w-[calc(100%-326px)] px-4 pt-[54px] duration-300">

          {/* Page Header */}
          <div className="crm-page-header">
            <div className="flex items-center justify-between">
              <div>
                <h1 className="crm-page-title">Activities</h1>
                <ol className="crm-breadcrumb">
                  <li><a href="/Analytics">Disploy</a></li>
                  <li>/</li>
                  <li>CRM</li>
                  <li>/</li>
                  <li className="active">Activities</li>
                </ol>
              </div>
              <button className="crm-new-btn" onClick={() => setOpenModel(true)}>
                <FaPlus size={11} />
                New Activity
              </button>
            </div>
          </div>

          <div className="xl:w-full min-h-[calc(100vh-138px)] relative pb-14">

            {/* Stat Cards */}
            <div className="crm-stats-row">
              <div className="crm-stat-card crm-card-indigo">
                <div className="flex items-start gap-3">
                  <div className="stat-icon stat-icon-indigo">
                    <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                      <circle cx="12" cy="12" r="10" />
                      <polyline points="12 6 12 12 16 14" />
                    </svg>
                  </div>
                  <div>
                    <p className="stat-label">Total Activities</p>
                    <p className="stat-value">{totalActs}</p>
                    <p className="stat-trend-up">↑ 10% vs last week</p>
                  </div>
                </div>
              </div>
              <div className="crm-stat-card crm-card-green">
                <div className="flex items-start gap-3">
                  <div className="stat-icon stat-icon-green">
                    <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  </div>
                  <div>
                    <p className="stat-label">Done Tasks</p>
                    <p className="stat-value">{doneActs}</p>
                    <p className="stat-trend-up">↑ 8% vs last week</p>
                  </div>
                </div>
              </div>
              <div className="crm-stat-card crm-card-blue">
                <div className="flex items-start gap-3">
                  <div className="stat-icon stat-icon-blue">
                    <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                      <circle cx="12" cy="12" r="10" />
                      <line x1="12" y1="8" x2="12" y2="12" />
                      <line x1="12" y1="16" x2="12.01" y2="16" />
                    </svg>
                  </div>
                  <div>
                    <p className="stat-label">To-Do Tasks</p>
                    <p className="stat-value">{todoActs}</p>
                    <p className="stat-trend-down">↓ 3% vs last week</p>
                  </div>
                </div>
              </div>
              <div className="crm-stat-card crm-card-sky">
                <div className="flex items-start gap-3">
                  <div className="stat-icon stat-icon-sky">
                    <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                    </svg>
                  </div>
                  <div>
                    <p className="stat-label">Calls</p>
                    <p className="stat-value">{callActs}</p>
                    <p className="stat-trend-up">↑ 15% vs last week</p>
                  </div>
                </div>
              </div>
              <div className="crm-stat-card crm-card-purple" style={{ borderTop: '4px solid #a855f7' }}>
                <div className="flex items-start gap-3">
                  <div className="stat-icon stat-icon-purple" style={{ color: '#a855f7', background: '#f3e8ff' }}>
                    <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                      <circle cx="9" cy="7" r="4" />
                      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                    </svg>
                  </div>
                  <div>
                    <p className="stat-label">Meetings</p>
                    <p className="stat-value">{meetingActs}</p>
                    <p className="stat-trend-up">↑ 12% vs last week</p>
                  </div>
                </div>
              </div>
              <div className="crm-stat-card crm-card-red">
                <div className="flex items-start gap-3">
                  <div className="stat-icon stat-icon-red">
                    <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                  </div>
                  <div>
                    <p className="stat-label">High Priority</p>
                    <p className="stat-value">{highPriorityActs}</p>
                    <p className="stat-trend-down">↓ 5% vs last week</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="crm-panel">
              {/* Tab Navigation + Filters */}
              <div className="flex items-center justify-between px-4 pt-2 border-b border-slate-100 flex-wrap gap-3">
                <div className="crm-tabs" style={{ borderBottom: 'none' }}>
                  <button
                    className={`crm-tab-btn ${activeButton === 1 ? 'active' : ''}`}
                    onClick={() => handleButtonClick(1)}
                  >
                    List
                  </button>
                  <button
                    className={`crm-tab-btn ${activeButton === 2 ? 'active' : ''}`}
                    onClick={() => handleButtonClick(2)}
                  >
                    Calendar
                  </button>
                </div>

                {activeButton === 1 && (
                  <div className="flex items-center gap-3 ml-auto pb-2">
                    <div className="crm-search-box">
                      <IoSearch size={14} />
                      <input
                        type="text"
                        placeholder="Search activities..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </div>

                    {selectedActivitysIds && selectedActivitysIds.length > 0 && (
                      <button
                        className="p-2 rounded-lg text-red-500 hover:bg-red-50 transition-colors"
                        onClick={DeleteActivitys}
                        title="Delete Selected"
                      >
                        <MdDeleteForever size={18} />
                      </button>
                    )}

                    <div className="relative">
                      <button
                        type="button"
                        className="p-2 hover:bg-slate-50 border border-slate-200 rounded-lg text-slate-500 hover:text-slate-800 transition-colors"
                        onClick={() => setAciteOption(!AciteOption)}
                      >
                        <RxDotsHorizontal size={16} />
                      </button>
                      {AciteOption && (
                        <div className="absolute right-0 mt-1 w-44 bg-white border border-slate-100 rounded-lg shadow-lg py-1 z-50 text-left">
                          {store?.getAllActivity?.totalRows > 0 && (
                            <button
                              onClick={handleExport}
                              className="w-full text-left px-4 py-2 text-xs font-semibold text-slate-700 hover:bg-indigo-50 hover:text-indigo-600 transition-colors"
                            >
                              Export file results
                            </button>
                          )}
                          <label className="w-full text-left px-4 py-2 text-xs font-semibold text-slate-700 hover:bg-indigo-50 hover:text-indigo-600 transition-colors cursor-pointer block">
                            <input
                              type="file"
                              className="hidden"
                              onChange={uploadExcel}
                              accept=".xls,.xlsx"
                            />
                            Import Data
                          </label>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>

            {loading && (<div className='h-screen'><Loading /></div>)}
            {!loading && activeButton === 1 && (
              <>
                <div className="relative scroll-inner">
                  <table className="crm-table text-center bg-white">
                    <thead>
                      <tr className="text-center">
                        <th scope="col" className="w-4 p-4 text-center">
                          <label className="custom-label">
                            <div className="bg-white dark:bg-slate-600/40 border border-slate-300 dark:border-slate-600 rounded w-4 h-4 inline-block leading-4 -mb-[3px]">
                              <input
                                type="checkbox"
                                checked={selectAll}
                                onChange={() => handleSelectAll()}
                              />
                            </div>
                          </label>
                        </th>
                        <th scope="col" className="mw-200 p-4">Done</th>
                        <th scope="col" className="mw-200 px-6 py-4">
                          <div className="flex justify-center items-center w-full">
                            Activity Name
                            {/* <svg
                              className="w-3 h-3 ms-1.5 cursor-pointer"
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="currentColor"
                              viewBox="0 0 24 24"
                              onClick={() => handleSort("activityName")}
                            >
                              <path
                                strokeWidth="2"
                                strokeLinecap="round"
                                d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Zm-6.852 0 3.426 5.05-3.426-5.05Z"
                              />
                            </svg> */}
                          </div>
                        </th>
                        <th scope="col" className="mw-200 p-4">MeetingType</th>
                        {/* <th scope="col" className="mw-200 p-4">Contact Person</th>
                        <th scope="col" className="mw-200 p-4">Organization</th>
                        <th scope="col" className="mw-200 p-4">Deal</th>
                        <th scope="col" className="mw-200 p-4">Lead</th>
                        <th scope="col" className="mw-200 p-4">Project</th> */}
                        <th scope="col" className="mw-200 p-4">Type</th>
                        <th scope="col" className="mw-200 p-4">Free/busy</th>
                        <th scope="col" className="mw-200 p-4">Priority</th>
                        {/* <th scope="col" className="mw-200 p-4">Note</th>
                        <th scope="col" className="mw-200 p-4">Public Description</th>
                        <th scope="col" className="mw-200 p-4">Location</th>
                        <th scope="col" className="mw-200 p-4">Due Date</th>
                        <th scope="col" className="mw-200 p-4">Add time</th>
                        <th scope="col" className="mw-200 p-4">Update time</th>
                        <th scope="col" className="mw-200 p-4">Mark as done time</th> */}
                        <th scope="col" className="mw-200 p-4">Action</th>
                      </tr>
                    </thead>

                    <tbody>
                      {sortedActivities && sortedActivities.length > 0 ? (
                        sortedActivities.map((item, index, arr) => {
                          const showUpward = index >= arr.length - 2 && arr.length > 1;
                          return (
                            <tr
                              className={`hover:bg-slate-50 transition-colors border-b border-slate-100 text-left ${getRowColorClass(item?.endDate)}`}
                              key={index}
                            >
                              <td className="w-4 px-4 py-3 ">
                                <label className="custom-label">
                                  <div className="bg-white dark:bg-slate-600/40 border border-slate-200 dark:border-slate-600 rounded w-4 h-4 inline-block leading-4  -mb-[3px]">
                                    <input
                                      type="checkbox"
                                      checked={selectedActivitysIds.includes(item.activityID)}
                                      onChange={() => handleCheckboxChange(item.activityID)}
                                    />
                                  </div>
                                </label>
                              </td>
                              <td
                                className="mw-200 px-4 py-3 text-sm whitespace-nowrap capitalize cursor-pointer "
                              >
                                <div
                                  className="relative flex-col group cursor-pointer text-white text-lg p-2.5  inline-flex items-center"
                                >
                                  <input
                                    checked={item?.markAsDone}
                                    type="radio"
                                    onClick={() => {
                                      const payload = {
                                        ActivityID: item.activityID,
                                        MarkAsDone: item?.markAsDone ? false : true,
                                      };
                                      dispatch(getMarkAsActivity(payload)).then((res) => {
                                        if (res.payload.status === true) {
                                          setloadFrist(true);
                                        }
                                      });
                                    }}
                                  />
                                  <div className="absolute bottom-4 flex-col items-center hidden mb-6 group-hover:flex">
                                    <span className="relative z-10 p-2 text-xs leading-none text-white whitespace-no-wrap bg-black rounded-md">{item?.markAsDone ? "To-Do" : "Done"}</span>
                                    <div className="w-3 h-3 -mt-2 rotate-45 bg-black"></div>
                                  </div>
                                </div>
                              </td>
                              <td
                                className="max-w-60 truncate py-3 text-sm font-medium capitalize cursor-pointer "
                                onClick={() => {
                                  setOpenModel(true);
                                  EditActivity(item?.activityID);
                                }}
                              >
                                <div className="flex items-center justify-center gap-2">
                                  <span>{getActivityIcon(item?.activityType)}</span>
                                  <span>{item?.activityName}</span>
                                </div>
                              </td>
                              <td className="mw-200 px-4 py-3 text-sm whitespace-nowrap text-slate-500 capitalize ">
                                {item?.meetingType}
                              </td>
                              {/* <td className="mw-200 px-4 py-3 text-sm whitespace-nowrap text-slate-500 capitalize ">
                                {item?.peopleName}
                              </td>
                              <td className="mw-200 px-4 py-3 text-sm whitespace-nowrap text-slate-500 capitalize ">
                                {item?.organizationName}
                              </td>
                              <td className="max-w-8 truncate px-4 py-3 text-sm whitespace-nowrap text-slate-500 capitalize ">
                                {item?.dealName}
                              </td>
                              <td className="mw-200 px-4 py-3 text-sm whitespace-nowrap text-slate-500 capitalize ">
                                {item?.leadName}
                              </td> 
                              <td className="mw-200 px-4 py-3 text-sm whitespace-nowrap text-slate-500 capitalize ">
                                {item?.projectName}
                              </td>*/}
                              <td className="mw-200 px-4 py-3 text-sm whitespace-nowrap text-slate-500 capitalize ">
                                {item?.activityType}
                              </td>
                              <td className="mw-200 px-4 py-3 text-sm whitespace-nowrap text-slate-500 capitalize ">
                                {item?.availableType}
                              </td>
                              <td className="mw-200 px-4 py-3 text-sm whitespace-nowrap text-slate-500 capitalize ">
                                {item?.priority}
                              </td>
                              {/* <td className="px-4 py-3 text-sm text-slate-500 capitalize ">
                                <p className="max-w-60 truncate-multi-line" dangerouslySetInnerHTML={{ __html: item?.notes }}></p>
                              </td>
                              <td className="max-w-60 truncate px-4 py-3 text-sm text-slate-500 capitalize ">
                                {item?.description}
                              </td>
                              <td className="max-w-60 truncate px-4 py-3 text-sm whitespace-nowrap text-slate-500 capitalize ">
                                {item?.locations}
                              </td>
                              <td className="mw-200 p-3 text-sm whitespace-nowrap text-slate-500 ">
                                {formatDate(item?.endDate)}
                              </td>
                              <td className="mw-200 p-3 text-sm whitespace-nowrap text-slate-500 ">
                                {item?.createdDate ? moment(item?.createdDate).format('LLL') : ''}
                              </td>
                              <td className="mw-200 p-3 text-sm whitespace-nowrap text-slate-500 ">
                                {item?.updatedDate ? moment(item?.updatedDate).format('LLL') : ''}
                              </td>
                              <td className="mw-200 p-3 text-sm whitespace-nowrap text-slate-500 ">
                                {item?.markAsDone && item?.markAsDoneTime ? moment(item?.markAsDoneTime).format('LLL') : ''}
                              </td> */}
                              <td className="px-4 py-3  whitespace-nowrap">
                                <div className="relative inline-block text-left">
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setOpenActionMenuId(openActionMenuId === item.activityID ? null : item.activityID);
                                    }}
                                    className="p-1.5 text-slate-500 hover:text-slate-800 hover:bg-slate-100 rounded-lg transition-colors"
                                  >
                                    <BsThreeDotsVertical size={16} />
                                  </button>
                                  {openActionMenuId === item.activityID && (
                                    <div className={`absolute right-0 w-36 bg-white border border-slate-100 rounded-lg shadow-lg py-1 z-50 animate-in fade-in duration-100 flex flex-col ${showUpward ? 'bottom-full mb-1 slide-in-from-bottom-1' : 'top-full mt-1 slide-in-from-top-1'}`}>
                                      <button
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setOpenModel(true);
                                          EditActivity(item?.activityID);
                                          setOpenActionMenuId(null);
                                        }}
                                        className="w-full flex items-center gap-2 px-3 py-2 text-xs font-semibold text-slate-700 hover:bg-indigo-50 hover:text-indigo-600 transition-colors text-left"
                                      >
                                        <BiEdit size={14} className="text-indigo-500" />
                                        <span>Edit</span>
                                      </button>
                                    </div>
                                  )}
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="20" className="text-center px-4 py-4 text-slate-500">
                            Data Not Found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <Pagination name='Activities' handlePageChange={handlePageChange} setCurrentPage={setCurrentPage} currentPage={currentPage} sidebarOpen={sidebarOpen} totalPages={totalPages} length={store?.getAllActivity?.totalRows} setrowsPerPage={setrowsPerPage} rowsPerPage={rowsPerPage} />
                </div>
              </>
            )}
            {activeButton === 2 && (<FullCalender setOpenModel={setOpenModel} />)}
          </div>
        </div>

        {openModel && (
          <AddActivity
            togglemodel={togglemodel}
            setloadFrist={setloadFrist}
            editActivityData={ActivityData}
          />
        )}
      </div>
    </div>
  );
}

